/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListingInspectorContextView } from './ListingInspectorContextView';
import type { TaskAssigneeView } from './TaskAssigneeView';
/**
 * One task: user-created (custom) or created by the Listing Inspector
 */
export type TaskItemView = {
    /**
     * Task UUID
     */
    id?: string;
    /**
     * Origin of the task
     */
    source?: TaskItemView.source;
    /**
     * Task title
     */
    title?: string;
    /**
     * Free-text details (custom tasks)
     */
    description?: string | null;
    /**
     * Workflow state
     */
    status?: TaskItemView.status;
    createdAt?: string;
    updatedAt?: string;
    /**
     * Analysis-derived context for listing_inspector tasks; null for custom tasks
     */
    listing?: ListingInspectorContextView | null;
    /**
     * Assigned account members; empty when unassigned
     */
    assignees?: Array<TaskAssigneeView>;
};
export namespace TaskItemView {
    /**
     * Origin of the task
     */
    export enum source {
        LISTING_INSPECTOR = 'listing_inspector',
        CUSTOM = 'custom',
    }
    /**
     * Workflow state
     */
    export enum status {
        OPEN = 'open',
        IN_PROGRESS = 'in_progress',
        DONE = 'done',
        DISMISSED = 'dismissed',
    }
}

